import React from "react";
import Header from "../../Components/Header";
import Feature from "../../Components/Feature";
import Footer from "../../Components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import SupportRight from "../Layouts/SupportRight";

export default function Support() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
          <UserLeftSidebar />
          <SupportRight />
        </div>
      </div>

      <Feature />
      <Footer />
    </div>
  );
}
